import { render } from "./PaymentConnectorTransactionNumberTable.vue?vue&type=template&id=5ca41d26"
import script from "./PaymentConnectorTransactionNumberTable.vue?vue&type=script&lang=js"
export * from "./PaymentConnectorTransactionNumberTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn});
